import React from 'react'
import { Flex, Typography } from 'antd'

export interface IStatusConfigs {
  configs: {
    color: string
    backgroundColor: string
    text: string
  }
}

const StatusTransaction: React.FC<IStatusConfigs> = (props) => {
  const { configs } = props

  return (
    <Flex
      style={{
        borderRadius: 27,
        padding: '8px 24px',
        backgroundColor: configs.backgroundColor,
        width: 'fit-content',
        alignItems: 'center',
        gap: 4,
      }}
    >
      <div
        style={{
          backgroundColor: configs.color,
          width: 4,
          height: 4,
          borderRadius: 50,
        }}
      />
      <Typography
        style={{
          color: configs.color,
          fontSize: 14,
          fontWeight: 700,
        }}
      >
        {configs.text}
      </Typography>
    </Flex>
  )
}

export default StatusTransaction
